module.exports = __webpack_public_path__ + "img/v.e2f08621.jpg";